export default __webpack_public_path__ + "static/media/peak-performance-sample.eac4794a.mp3";